export default function Worker_fn() {
  return new Worker("/dist/8.2.6.136/" + "C2paMp4.vbworker.min.worker.js");
}
